/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SearchPlayerEmail200ResponseResults
 */
export interface SearchPlayerEmail200ResponseResults {
    /**
     * 
     * @type {boolean}
     * @memberof SearchPlayerEmail200ResponseResults
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerEmail200ResponseResults
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerEmail200ResponseResults
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerEmail200ResponseResults
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerEmail200ResponseResults
     */
    email?: string;
}


/**
 * Check if a given object implements the SearchPlayerEmail200ResponseResults interface.
 */
export function instanceOfSearchPlayerEmail200ResponseResults(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SearchPlayerEmail200ResponseResultsFromJSON(json: any): SearchPlayerEmail200ResponseResults {
    return SearchPlayerEmail200ResponseResultsFromJSONTyped(json, false);
}

export function SearchPlayerEmail200ResponseResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPlayerEmail200ResponseResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'active': !exists(json, 'active') ? undefined : json['active'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function SearchPlayerEmail200ResponseResultsToJSON(value?: SearchPlayerEmail200ResponseResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'active': value.active,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'number': value.number,
        'email': value.email,
    };
}

